<template>
    <div
        :class="{ drawn }"
        class="cropper"
        @mousedown.stop="startCrop"
        @mousemove.stop="moveCrop"
        @mouseup.stop="stopCrop"
    >
        <div
            :style="{width: x + 1 + 'px'}"
            class="grey"
        />
        <div
            :style="{left: x + 1 + 'px', width: width - 2 + 'px', height: y + 1 + 'px'}"
            class="grey"
        />
        <div
            :style="{left: x - 1 + width + 'px'}"
            class="grey"
        />
        <div
            :style="{left: x + 1 + 'px', width: width - 2 + 'px', top: height + y - 1 + 'px'}"
            class="grey"
        />

        <CropBox
            :drawn="drawn"
            :drawing="drawing"
            :x="x"
            :y="y"
            :width="width"
            :height="height"
            @setDimensions="setDimensions"
        />
    </div>
</template>

<script>
import { CropBox } from '.';

export default {
    name: 'Cropper',
    components: { CropBox },
    props: {
        edit: {
            required: true,
            validator(value) {
                return typeof value === 'boolean' || typeof value === 'object';
            }
        }
    },
    data() {
        return {
            drawn: false,
            drawing: false,
            xy: {
                x: 0,
                y: 0
            }
        };
    },
    computed: {
        x() {
            return Math.min(this.edit.cropDimensions.x0, this.edit.cropDimensions.x1);
        },
        y() {
            return Math.min(this.edit.cropDimensions.y0, this.edit.cropDimensions.y1);
        },
        width() {
            return Math.abs(this.edit.cropDimensions.x0 - this.edit.cropDimensions.x1);
        },
        height() {
            return Math.abs(this.edit.cropDimensions.y0 - this.edit.cropDimensions.y1);
        }
    },
    methods: {
        setDimensions(e) {
            this.edit.cropDimensions = {
                x0: e.x,
                y0: e.y,
                x1: e.x + e.width,
                y1: e.y + e.height
            };
        },
        startCrop(e) {
            this.drawing = true;
            this.xy.x = e.layerX || e.offsetX;
            this.xy.y = e.layerY || e.offsetY;
        },
        moveCrop(e) {
            if (this.drawing) {
                const x1 = e.layerX || e.offsetX;
                const y1 = e.layerY || e.offsetY;

                this.edit.cropDimensions = {
                    x0: this.xy.x,
                    y0: this.xy.y,
                    x1,
                    y1
                };
                this.drawn = true;
            }
        },
        stopCrop(e) {
            this.drawing = false;

            const x = e.layerX || e.offsetX;
            const y = e.layerY || e.offsetY;

            if (this.xy.x === x || this.xy.y === y) {
                this.drawn = false;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.cropper {
    position: absolute;
    cursor: crosshair;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    overflow: hidden;
}

.drawn {
    .grey {
        opacity: 0.4;
    }
}

.grey {
    opacity: 0;
    pointer-events: none;
    user-select: none;
    background-color: #000000;
    transition: opacity .5s;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: -1;
}
</style>
